import { Button, Popover, Tooltip } from 'antd';
import { memo, SyntheticEvent, useState } from 'react';
import { useAuth } from 'hooks/useAuth';
import { EllipsisOutlined, CheckOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { dateToDuration, parseNotificationData } from './utils';

const DIV = styled.div`
  &:hover {
    background: #e5f0ff;
  }
`;

type TNotificationItemProps = {
  notification: any;
  markNotificationsAs: (notis: any[], isViewed: boolean) => Promise<void>;
};

export const NotificationItem = memo(({ notification, markNotificationsAs }: TNotificationItemProps) => {
  const { user } = useAuth();

  const [isMarkAsOpen, setIsMarkAsOpen] = useState<boolean>(false);

  const handleClick = async (n: any, path?: string) => {
    await markNotificationsAs([n], true);

    if (path) {
      window.location.href = path;
    }
  };

  const markAs = () => {
    markNotificationsAs([notification], !notification.isViewed);
  };

  const handleAction = (e: SyntheticEvent<HTMLElement>) => {
    markAs();
    setIsMarkAsOpen(false);
    e.stopPropagation();
  };

  const { svgIcon, actionText, actionUrl } = parseNotificationData(notification, user?.type);

  return (
    <Tooltip title={actionText}>
      <DIV className="flex cursor-pointer px-3 py-4" onClick={() => handleClick(notification, actionUrl)}>
        <div className="flex-none">
          <div className="flex align-items-center justify-content-center mr-3">{svgIcon}</div>
        </div>
        <div className="grow w-full">
          <div className="notification-list-header flex justify-content-between align-items-center w-full">
            <span
              className="text-base w-9"
              style={{ wordBreak: 'break-word', fontWeight: notification.isViewed ? '400' : '700' }}
            >
              {notification.title}
            </span>
            <span className="text-xs text-body">{dateToDuration(notification.createdAt)}</span>
          </div>
          <div className="mt-2 flex align-items-end">
            <div
              className="text-xs w-full"
              style={{ wordBreak: 'break-word' }}
              dangerouslySetInnerHTML={{ __html: notification.message }}
            />

            <Popover
              placement="bottomLeft"
              visible={isMarkAsOpen}
              onVisibleChange={setIsMarkAsOpen}
              content={
                <Button icon={<CheckOutlined />} style={{ color: '#DA3A6D' }} onClick={handleAction}>
                  {notification.isViewed ? 'Mark as unread' : `Mark as read`}
                </Button>
              }
            >
              <Button icon={<EllipsisOutlined />} onClick={(e) => e.stopPropagation()} style={{ height: 28 }} />
            </Popover>
          </div>
        </div>
      </DIV>
    </Tooltip>
  );
});
